import { createContext } from 'react';

export default createContext({
  selectedFilter: null,
  setVisible() {},
  sectionInView: false,
  isChatbotOpened: false,
});
